import { useEffect } from 'react';

interface DocumentMetaOptions {
  title: string;
  description?: string;
  path: string;
}

const BASE_URL = import.meta.env.VITE_SITE_URL || 'https://heseda.ai';

/**
 * Updates document <title>, canonical link, og:url, and og:title for the current route.
 * Lightweight alternative to react-helmet for SPA per-route meta.
 */
export function useDocumentMeta({ title, description, path }: DocumentMetaOptions): void {
  useEffect(() => {
    document.title = title;

    const canonicalUrl = `${BASE_URL}${path}`;

    // canonical link
    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical) {
      canonical.href = canonicalUrl;
    } else {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = canonicalUrl;
      document.head.appendChild(canonical);
    }

    // og:url
    const ogUrl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.content = canonicalUrl;
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = canonicalUrl;
      document.head.appendChild(meta);
    }

    // og:title
    const ogTitle = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
    if (ogTitle) ogTitle.content = title;

    // description + og:description
    if (description) {
      const desc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (desc) desc.content = description;

      const ogDesc = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');
      if (ogDesc) ogDesc.content = description;
    }
  }, [title, description, path]);
}
